import { Link } from 'react-router-dom';
import LoginForm from '../../components/Auth/LoginForm';

const Login = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-md">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-center mb-6">Login to OpportunAI</h1>
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;